var path = '/app/webpack/wealthbar/components/search/search.html.slim';
var html = "<i class=\"wbf wbf-search\"></i><span>Search by name, account #, or phone</span><span class=\"micro\">Just start typing...</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;